import React, { useState } from 'react';
import {
    useFloating,
    useDismiss,
    useRole,
    useClick,
    useInteractions,
    FloatingFocusManager,
    FloatingOverlay,
    FloatingPortal,
} from '@floating-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from 'icons';
import { solid } from 'icons';
import { useMyDNVContext } from 'mydnv/context/mydnv-context';
import { FollowedInfoCard } from 'components/page-title/followed-infocard/followed-infocard';

const { faEnvelopeOpenText } = solid;

export const VerifyEmailAddress = (props) => {
    const { emailAddress, showVerifiedBanner } = props;

    const { refs, context } = useFloating({
        open: props.isOpen,
        onOpenChange: props.setModalOpen,
    });
    const click = useClick(context);
    const role = useRole(context);
    const dismiss = useDismiss(context, { outsidePressEvent: 'mousedown' });
    const { getFloatingProps } = useInteractions([click, role, dismiss]);
    const [disableResend, setDisableResend] = useState(false);

    const { showVerifySent, showVerifySpinner, setShowVerifySpinner, setShowVerifySent } = useMyDNVContext();

    const handleResend = () => {
        setDisableResend(true);
        setShowVerifySpinner(true);
        // re-setting to false because email is sent when modal opens
        setShowVerifySent(false);
        props.setModalOpen("resend-verification-email");
    }

    return (
        <>
            <FloatingPortal>
                {props.isOpen && (
                    <FloatingOverlay className="modal-overlay" lockScroll>
                        <FloatingFocusManager context={context}>
                            <div className='tall-modal verify-email' ref={refs.setFloating} {...getFloatingProps()}>
                                <div className='button-wrapper skip'>
                                    {!showVerifiedBanner && <button onClick={() => props.setModalOpen('sign-out')} className='btn btn-link'>
                                        Skip for now
                                    </button>}
                                </div>
                                {showVerifiedBanner && <FollowedInfoCard type='email-verified'/>}
                                <h2>Check your email</h2>
                                <p>We&apos;ve sent a verification link to:</p>

                                <div className="email-address">
                                    <FontAwesomeIcon icon={faEnvelopeOpenText} />
                                    {emailAddress}
                                </div>
                                <p>Select the link in the email to verify your MyDNV account.</p>
                                <h3>Didn&apos;t receive the email?</h3>
                                <ul>
                                    <li>Check your spam or junk folder</li>
                                    <li>Make sure your email address is correct</li>
                                </ul>
                                <div className="button-wrapper">
                                    <button
                                        className="btn btn-link"
                                        onClick={() => handleResend()}
                                        disabled={disableResend || showVerifiedBanner}
                                    >
                                        Resend verification email
                                    </button>
                                    {disableResend && showVerifySpinner && (
                                        <FontAwesomeIcon icon={icons.solid.faSpinner} />
                                    )}
                                    {disableResend && showVerifySent && <FontAwesomeIcon icon={icons.solid.faCheck} />}
                                    <br />
                                    <button
                                        className='btn btn-link'
                                        onClick={() => props.setModalOpen('sign-out-sign-up')}
                                        disabled={showVerifiedBanner}
                                    >
                                        Update my email address
                                    </button>
                                </div>
                            </div>
                        </FloatingFocusManager>
                    </FloatingOverlay>
                )}
            </FloatingPortal>
        </>
    );
};
